module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"SocialNetworkLinks":{"label":"Sledujte nás"}},"en":{"SocialNetworkLinks":{"label":"Follow us"}}}')
  delete Component.options._Ctor
}
